import { PATHWAY_MENU_TYPES, SECTION_STATUS } from '@routes/sidebar/___shared___/components/pathway-menu/constants.ts';
import type {
    LearningElement,
    LearningElementTypes,
    LearningOverviewResponse,
    LearningSection,
} from '@routes/sidebar/learning/___pages___/learning-overview/api/learningOverview.api.ts';
import { isCompletedOrRefresherPathway } from '@routes/sidebar/learning/___pages___/learning-overview/ui/pathway-menu/utils.tsx';

const getSectionLearningElements = (sections: LearningSection[]): LearningElement[] =>
    sections.flatMap((section) => {
        return [...(section.elements ?? []), ...getSectionLearningElements(section.subSections ?? [])];
    });

export const getLearningOverviewElements = (learningOverview?: LearningOverviewResponse | null): LearningElement[] => [
    ...getSectionLearningElements(learningOverview?.sections ?? []),
    ...(learningOverview?.finalQuiz ? [learningOverview.finalQuiz] : []),
];

export const resetLearningElementProgress = (element: LearningElement): LearningElement => ({
    ...element,
    learningElementState: SECTION_STATUS.NEW,
});

export const resetLearningSectionsProgress = (sections: LearningSection[]): LearningSection[] =>
    sections.map((section) => ({
        ...section,
        elements: section.elements.map(resetLearningElementProgress),
        subSections: resetLearningSectionsProgress(section.subSections ?? []),
    }));

export const isYouTubeElementType = (
    learningItemId: number | null,
    learningOverview: LearningOverviewResponse | null,
) => {
    if (learningOverview === null || learningItemId === null) return false;
    const learningElement = getLearningOverviewElements(learningOverview).find((le) => le.id === learningItemId);

    return learningElement ? learningElement.learningElementType === PATHWAY_MENU_TYPES.YOUTUBE : false;
};

export const makeNavKey = (item: LearningElement) => `${item.name}-${item.id}`;

// TODO: use this when decision about blocking final quiz will be made
export const lockFinalQuizUntilCompletePathway = (
    learningElements: LearningElement[],
    learningElementType: LearningElementTypes,
): boolean => {
    const allElementsFinishedExceptLast = learningElements
        .slice(0, -1)
        .every((el) => isCompletedOrRefresherPathway(el.learningElementState));

    return !allElementsFinishedExceptLast && learningElementType === PATHWAY_MENU_TYPES.FINAL_QUIZ;
};
